import React from "react";
import { Col, Row } from "react-bootstrap";
import { accountTypesToEnglishMapping } from "statics/accountTypes";

import IconHeader from "components/IconHeader";
import IconSubheader from "components/IconSubheader";
import type { IraAccount } from "types/models";

import "./ProfileInfoCard.scss";

// Matches the redux `state.user.profile` shape (declared display fields plus
// the arbitrary backend keys the slice carries) so the connected parent can
// pass `this.props.userInfo` through without a cast.
interface ProfileUserInfo {
  firstName?: string;
  lastName?: string;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  phoneNumber?: string;
  [key: string]: unknown;
}

interface ProfileInfoCardProps {
  userInfo?: ProfileUserInfo;
  iraAccounts?: IraAccount[];
}

function ProfileInfoCard({
  userInfo = {},
  iraAccounts = [],
}: ProfileInfoCardProps) {
  return (
    <div className="profile-card-containter">
      <Row>
        <Col>
          <IconHeader variant="cardHeader" headerText="Profile Information" />
          <IconSubheader subheader="You can edit your profile at any time." />

          <div className="information-section">
            <p className="title">Legal Name</p>
            <p className="subtext">
              {userInfo.firstName} {userInfo.lastName}
            </p>
          </div>

          <div className="information-section">
            <p className="title">Address</p>

            <p className="subtext">
              {userInfo.address1} {userInfo.address2}
            </p>

            <p className="subtext">
              {userInfo.city} {userInfo.state} {userInfo.postalCode}
            </p>
          </div>

          <div className="information-section">
            <p className="title">Phone Number</p>
            <p className="subtext">{userInfo.phoneNumber}</p>
          </div>

          <div className="information-section">
            <p className="title">Active Accounts and Account Numbers</p>
            {iraAccounts.map((account) => (
              // PRESERVED BUG (conversion-only): IraAccount has no `key` field,
              // so this is always undefined and React falls back to index keys.
              // @ts-expect-error preserved missing-key access
              <p className="subtext" key={account.key}>
                {
                  accountTypesToEnglishMapping[
                    account.accountType as keyof typeof accountTypesToEnglishMapping
                  ]
                }
                : {account.accountNumber}
              </p>
            ))}
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default ProfileInfoCard;
